import { memo } from "react";

const Channels = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_278_2765)">
      <path
        d="M3.33334 11.6667C4.2538 11.6667 5.00001 10.9205 5.00001 10C5.00001 9.07958 4.2538 8.33337 3.33334 8.33337C2.41286 8.33337 1.66667 9.07958 1.66667 10C1.66667 10.9205 2.41286 11.6667 3.33334 11.6667Z"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 3.33329C17.9602 3.33329 18.3333 2.9602 18.3333 2.49996C18.3333 2.03972 17.9602 1.66663 17.5 1.66663C17.0397 1.66663 16.6667 2.03972 16.6667 2.49996C16.6667 2.9602 17.0397 3.33329 17.5 3.33329Z"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.8333C17.9602 10.8333 18.3333 10.4602 18.3333 9.99996C18.3333 9.53971 17.9602 9.16663 17.5 9.16663C17.0397 9.16663 16.6667 9.53971 16.6667 9.99996C16.6667 10.4602 17.0397 10.8333 17.5 10.8333Z"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 18.3333C17.9602 18.3333 18.3333 17.9602 18.3333 17.5C18.3333 17.0397 17.9602 16.6666 17.5 16.6666C17.0397 16.6666 16.6667 17.0397 16.6667 17.5C16.6667 17.9602 17.0397 18.3333 17.5 18.3333Z"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 2.5H8.33333V17.5H13.3333"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 10H13.3333"
        stroke="currentColor"
        strokeWidth="1.37741"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_278_2765">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(Channels);
